module.exports = __webpack_public_path__ + "img/34_12.d8831397.png";